import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class GetOrderInfoService {
  private _env: string = this.env._env;
  private url = null;

  constructor(private http: HttpClient, private env: EnvironmentService) {}

  public getContalinkOrderInfo(getOrderInfo: GetOrderInfo): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders().set('X-Api-Key', environment[this._env]['back_end_api_token']);
    let params = new HttpParams().set("payment_order_id", getOrderInfo.payment_order_id);

    this.url = `${environment[this._env]['back_end_url']}/orderinfo`;

    return this.http.get(this.url, {
      headers: headers,
      params: params
    });
  }
}
export interface GetOrderInfo {
  payment_order_id:string
}